<script setup>
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import AnalyzerMap from '#/analyzer/AnalyzerMap'
import B2CQuestionnairePopup from 'components/analyzer/B2CQuestionnairePopup'
import B2CMailNotificationPopup from 'components/analyzer/B2CMailNotificationPopup'
import B2CMaxRequestPopup from 'components/detailsReport/B2CMaxRequestPopup'
import { onMounted, ref } from 'vue'
import B2CQuickView from 'components/analyzer/B2CQuickView'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useMeta } from 'quasar'

const { userAuthenticated, analyzerType } = useAnalyzer()
const { globalConfiguration } = useGlobalStore()
if (globalConfiguration.value && globalConfiguration.value.pages && globalConfiguration.value.pages.b2cAnalyzer) {
  useMeta({
    title: globalConfiguration.value.pages.b2cAnalyzer.title,
    meta: {
      description: { name: 'description', content: globalConfiguration.value.pages.b2cAnalyzer.description },
      keywords: { name: 'keywords', content: globalConfiguration.value.pages.b2cAnalyzer.keyword },
      canonical: { rel: 'canonical', href: 'https://raumpioniere.ch/b2c/analyzer' },
      'og:title': { property: 'og:title', content: globalConfiguration.value.pages.b2cAnalyzer.ogTitle ? globalConfiguration.value.pages.b2cAnalyzer.ogTitle : globalConfiguration.value.pages.b2cAnalyzer.title },
      'og:image': { property: 'og:image', content: globalConfiguration.value.pages.b2cAnalyzer.ogImage ? globalConfiguration.value.pages.b2cAnalyzer.ogImage : 'https://raumpioniere.ch/icons/favicon-128x128.png' },
      'og:url': { property: 'og:url', content: 'https://raumpioniere.ch/b2c/analyzer' },
      'og:description': { property: 'og:description', content: globalConfiguration.value.pages.b2cAnalyzer.ogDescription ? globalConfiguration.value.pages.b2cAnalyzer.ogDescription : globalConfiguration.value.pages.b2cAnalyzer.description },
      'og:type': { property: 'og:type', content: globalConfiguration.value.pages.b2cAnalyzer.ogType ? globalConfiguration.value.pages.b2cAnalyzer.ogType : 'B2B Analyzer' },
      'og:locale': { property: 'og:locale', content: 'de_CH' }
    }
  })
}
userAuthenticated.value = false
analyzerType.value = 'B2C'

const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
</script>

<template lang="pug">
div
  b2-c-questionnaire-popup
  b2-c-mail-notification-popup
  b2-c-max-request-popup
  b2-c-quick-view
  analyzer-map(page="B2CAnalyzer" v-if="mounted")
</template>

<style lang="sass">
.mapboxgl-ctrl-bottom-left, .mapboxgl-ctrl-bottom-right
  @media screen and (max-width: 599px)
.mapboxgl-canvas
  position: absolute
  top: 0
  bottom: 0
  width: 100% !important
  @media screen and (min-width: 600px)
    height: 100% !important
  @media screen and (max-width: 599px)
    height: 100% !important
.noMoreFreeDetailsReportPopup
  .bodyText
    font-size: 16px
    line-height: 170%
    letter-spacing: 0.03em
    color: #464D5F
    margin-bottom: 10px
    vertical-align: middle
</style>
